<template>
    <div class="preservation-xwxx">
        <Slogan theTitle="行为信息"/>
        <van-cell-group class="xwxx-box" v-for="(item, index) in this.bqXwxx" :key="index">
            <van-field
                v-model="item.nXwbqsx"
                readonly
                label="行为保全事项"
            ></van-field>
            <van-field
                v-model="item.cSxsm"
                readonly
                label="事项说明"
                @click="toastJointCcxx(item.cSxsm)"
            ></van-field>
        </van-cell-group>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import {getXcxXwList} from "@/api/guarantee";
    import {typeXwbqsx} from "@/filters";
    import {Toast} from "vant";

    export default {
    name: "previewXWXX",
        data() {
            return {
                bqXwxx:[]
            };
        },
        // 注入
        inject: ['bqid'],
        components: {Slogan},
        methods: {
            toastJointCcxx(value){
                if(!value){
                    return
                }
                Toast(value);
            },
            getBqXwxx(){
                let bqid = this.bqid
                getXcxXwList({bqid}).then(res=>{
                    if(res.code===200&&res.data.length>0){
                        res.data.map(item=>{
                            this.bqXwxx.push({
                                cId:item.cId,
                                nXwbqsx:typeXwbqsx(item.nXwbqsx),
                                cSxsm:item.cSxsm
                            });
                        });
                    }
                });
            }
        },
        mounted() {
            this.getBqXwxx()
        }
    }
</script>

<style lang="less"  scoped>
.xwxx-box {
    position: relative;
}
</style>
